var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 619.92 480.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-14,.cls-15,.cls-6,.cls-8,.cls-9{fill:#fff;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-2,.cls-5,.cls-7,.cls-8,.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-1,.cls-7{stroke-width:2.22px;}.cls-2{fill:#7b33a3;stroke-width:1.67px;}.cls-13,.cls-3{fill:#f0c62f;}.cls-4{fill:#da004f;}.cls-5{fill:none;stroke-width:4.49px;}.cls-7{fill:#e3cea1;}.cls-8{stroke-width:0.3px;}.cls-9{stroke-width:0.24px;}.cls-10{fill:#ffcb00;stroke-width:1.41px;}.cls-11{stroke-width:1.34px;}.cls-12,.cls-16{fill:#da00c6;}.cls-12,.cls-13{stroke-width:2.24px;}.cls-14{stroke-width:1.76px;}.cls-15{stroke-width:1.69px;}.cls-17{fill:#77c12d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.9,307.86V62.78a35.6,35.6,0,0,0-35.6-35.6h-71a35.6,35.6,0,0,0-35.6,35.6V299.65a77.47,77.47,0,1,0,146.7,34.78C295.39,325.1,290.9,307.86,290.9,307.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 200.83,
    y: 49.84,
    width: 36.88,
    height: 178.25,
    rx: 11.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.93,281.45a31.81,31.81,0,0,1-62.35-.39,61,61,0,1,0,62.35.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.88,326.61s13.38,37,41.83,27.29-7.49-41.17,23.95-20.21,35.93,22.45,27.69-9.73,27,15,27,15l-2.94,18.6-21.12,25.76-21.39,10S159.71,405.61,158.88,326.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.93,281.45a31.81,31.81,0,0,1-62.35-.39,61,61,0,1,0,62.35.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 214.27,
    cy: 381.15,
    r: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.52,
    y: 37.37,
    width: 26.66,
    height: 172.19,
    rx: 7.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 195.52,
    y: 79.58,
    width: 20,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 204.41,
    y: 99.58,
    width: 17.77,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 195.52,
    y: 137.35,
    width: 6.67,
    height: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 204.41,
    y: 165.12,
    width: 17.77,
    height: 5.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.8,239.7c-14.83,27.47-14.46,40.6-14.46,40.6a14.06,14.06,0,1,0,28.1,1.26C234.69,275.31,219.8,239.7,219.8,239.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 226.9,
    cy: 282.45,
    r: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 431.33,
    width: 169.12,
    height: 22.82,
    rx: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M526,21.6V19.13a19.13,19.13,0,0,0-38.26,0v2.33a72.49,72.49,0,0,0-53.6,70V435.71h145V91.44A72.5,72.5,0,0,0,526,21.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.32,338a70.84,70.84,0,0,1-70.81,70.87h-3.35a70.61,70.61,0,0,1-52-22.8v49.64h145V91.44C579.11,69.91,560.32,338,560.32,338Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.92,47c-5.46,0-8.85,4.21-12.94,9.61-6.46,8.51-10.52,20.95-10.52,34.81v52.4c0,1.67.9,3,2,3h0c2.89,0,5.23-3.49,5.23-7.8V93.63c0-21.48,9.76-39.54,23-44.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 442.03,
    y: 156.41,
    width: 6.83,
    height: 28.57,
    rx: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.86,433.17a11.14,11.14,0,0,1,.16-1.84h-5.36a11.41,11.41,0,0,0,0,22.82H580a11.4,11.4,0,0,0,11.24-9.57H450.27A11.41,11.41,0,0,1,438.86,433.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M577.14,431.33H439a9,9,0,0,0,1.85,7.42,15.25,15.25,0,0,0,12.21,5.83H585.64a4.62,4.62,0,0,0,3.81-7.28l-.1-.14A15.25,15.25,0,0,0,577.14,431.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M432.76,217.8c-.11-1.77-.18-3.88-.4-6-.36-3.47-.66-6.95-1.29-10.37-1.55-8.32-5.51-12.39-13.86-13.84-4.93-.85-9.95-1.12-14.94-1.65a4.29,4.29,0,0,1-1.58-.32c2-.13,4-.15,6-.39,4.09-.5,8.2-.91,12.23-1.73,6.32-1.27,10.19-5.24,11.75-11.52a90.55,90.55,0,0,0,2.05-16.8,8.22,8.22,0,0,1,.26-1.71c.3,3.83.55,7.67.94,11.5.23,2.15.64,4.28,1.08,6.4,1.44,6.85,5.63,11.12,12.48,12.33,5.18.92,10.45,1.29,15.68,1.89a17.19,17.19,0,0,0,1.9,0l0,.34c-.46,0-.91,0-1.36.09-5.23.56-10.5.91-15.7,1.74-7.82,1.23-12.2,6.15-13.37,13.85C433.87,207.1,433.37,212.6,432.76,217.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M399.37,412.41a292,292,0,0,0-95.74,0H247V444c0,19.61,46.8,35.51,104.53,35.51S456,463.57,456,444V412.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 351.5,
    cy: 412.41,
    rx: 104.53,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,412.45l-.47-1.88c-.11-.42.1-.74.62-1a4.76,4.76,0,0,1,1.88-.37l11,0a6.74,6.74,0,0,1,1-6,13.27,13.27,0,0,1,5.57-4.12,30.63,30.63,0,0,1,8.76-2.15,55.41,55.41,0,0,1,11-.05,36.62,36.62,0,0,1,8.54,1.63,29,29,0,0,1,6.25,2.85,27.72,27.72,0,0,1,4.68,3.64q2,2,3.81,4l29.89-.1a9.61,9.61,0,0,0-2.1-2.67,29.74,29.74,0,0,0-2.55-2.05c-.84-.59-1.57-1.08-2.2-1.49s-1-.76-1.05-1a.67.67,0,0,1,.25-.73,3.43,3.43,0,0,1,1.2-.52l3.63-1.07a35.74,35.74,0,0,1,7.1,4.14,15,15,0,0,1,4.55,5.41l12-.06.47,1.88c.1.39-.12.71-.65.95a4.92,4.92,0,0,1-2,.38l-8.89,0a6.56,6.56,0,0,1-.9,5.67,12.24,12.24,0,0,1-5,3.89,26.73,26.73,0,0,1-7.86,2.06,47.08,47.08,0,0,1-9.75.1,42,42,0,0,1-8.79-1.57,30.33,30.33,0,0,1-6.36-2.71,25.08,25.08,0,0,1-4.65-3.45q-2-1.89-3.62-3.81l-32.85.12a10.39,10.39,0,0,0,2.8,3.53,32.23,32.23,0,0,0,3.57,2.56c1.18.73,2.21,1.34,3.1,1.83s1.39.91,1.48,1.26c.15.59-.25,1-1.2,1.3l-4.41,1.38A38.7,38.7,0,0,1,310,419a17.8,17.8,0,0,1-5.26-6.57Zm85.46,6.66a13.64,13.64,0,0,0,4.37-1.13,6.94,6.94,0,0,0,2.86-2.32,5.21,5.21,0,0,0,.85-3.53l-27.86.1a34.9,34.9,0,0,0,2.71,2.44,19,19,0,0,0,3.14,2.07,20.79,20.79,0,0,0,3.8,1.54,22.86,22.86,0,0,0,4.68.85A28.24,28.24,0,0,0,376.32,419.11Zm-54.19-17.47a17.55,17.55,0,0,0-5.25,1.29,8,8,0,0,0-3.3,2.52,5.65,5.65,0,0,0-1,3.7l30.92-.1q-1.26-1.37-2.64-2.61a17.54,17.54,0,0,0-3.08-2.22,19.18,19.18,0,0,0-3.86-1.66,23,23,0,0,0-4.89-.91A36.74,36.74,0,0,0,322.13,401.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M399.37,345.35a292,292,0,0,0-95.74,0H247V376.9c0,19.61,46.8,35.51,104.53,35.51S456,396.51,456,376.9V345.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 351.5,
    cy: 345.35,
    rx: 104.53,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,345.39l-.47-1.88c-.11-.41.1-.74.62-1a4.76,4.76,0,0,1,1.88-.37l11,0a6.74,6.74,0,0,1,1-6,13.27,13.27,0,0,1,5.57-4.12,30.63,30.63,0,0,1,8.76-2.15,56.18,56.18,0,0,1,11-.05,36.62,36.62,0,0,1,8.54,1.63,29,29,0,0,1,6.25,2.85,27.72,27.72,0,0,1,4.68,3.64q2,2,3.81,4l29.89-.1a9.61,9.61,0,0,0-2.1-2.67,27.76,27.76,0,0,0-2.55-2c-.84-.59-1.57-1.09-2.2-1.5s-1-.75-1.05-1a.66.66,0,0,1,.25-.72,3.24,3.24,0,0,1,1.2-.53l3.63-1.07a35.74,35.74,0,0,1,7.1,4.14,15,15,0,0,1,4.55,5.41l12-.06.47,1.88c.1.39-.12.71-.65.95a4.92,4.92,0,0,1-2,.38l-8.89,0a6.55,6.55,0,0,1-.9,5.66,12.16,12.16,0,0,1-5,3.89,26.43,26.43,0,0,1-7.86,2.06,47.76,47.76,0,0,1-9.75.11,42.6,42.6,0,0,1-8.79-1.58,30.33,30.33,0,0,1-6.36-2.71,24.64,24.64,0,0,1-4.65-3.45c-1.31-1.26-2.52-2.52-3.62-3.81l-32.85.12a10.39,10.39,0,0,0,2.8,3.53,32.37,32.37,0,0,0,3.57,2.57c1.18.72,2.21,1.33,3.1,1.82s1.39.91,1.48,1.26c.15.59-.25,1-1.2,1.31l-4.41,1.37a38.7,38.7,0,0,1-8.82-5.26,17.8,17.8,0,0,1-5.26-6.57Zm85.46,6.66a13.64,13.64,0,0,0,4.37-1.13,6.92,6.92,0,0,0,2.86-2.31,5.25,5.25,0,0,0,.85-3.54l-27.86.1c.86.86,1.76,1.67,2.71,2.45a18.31,18.31,0,0,0,3.14,2.06,20.79,20.79,0,0,0,3.8,1.54,22.86,22.86,0,0,0,4.68.85A28.24,28.24,0,0,0,376.32,352.05Zm-54.19-17.47a17.55,17.55,0,0,0-5.25,1.29,8,8,0,0,0-3.3,2.52,5.65,5.65,0,0,0-1,3.7l30.92-.1q-1.26-1.37-2.64-2.61a17.54,17.54,0,0,0-3.08-2.22,19.18,19.18,0,0,0-3.86-1.66,23,23,0,0,0-4.89-.91A36.74,36.74,0,0,0,322.13,334.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M399.37,274.34a292.77,292.77,0,0,0-95.74,0H247V305.9c0,19.61,46.8,35.5,104.53,35.5S456,325.51,456,305.9V274.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 351.5,
    cy: 274.34,
    rx: 104.53,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,274.39l-.47-1.88c-.11-.42.1-.74.62-1a4.59,4.59,0,0,1,1.88-.37l11,0a6.73,6.73,0,0,1,1-6,13.37,13.37,0,0,1,5.57-4.13,31,31,0,0,1,8.76-2.14,56.14,56.14,0,0,1,11-.06,37.69,37.69,0,0,1,8.54,1.63,29.5,29.5,0,0,1,6.25,2.86,27.22,27.22,0,0,1,4.68,3.64c1.35,1.33,2.62,2.65,3.81,4l29.89-.09a9.47,9.47,0,0,0-2.1-2.67,26.33,26.33,0,0,0-2.55-2.05c-.84-.59-1.57-1.09-2.2-1.5s-1-.75-1.05-1a.67.67,0,0,1,.25-.73,3.41,3.41,0,0,1,1.2-.53l3.63-1.07a36.74,36.74,0,0,1,7.1,4.14,15.14,15.14,0,0,1,4.55,5.42l12-.06.47,1.88c.1.39-.12.71-.65.95a4.76,4.76,0,0,1-2,.37l-8.89,0a6.57,6.57,0,0,1-.9,5.67,12.32,12.32,0,0,1-5,3.89,26.73,26.73,0,0,1-7.86,2.06,47.08,47.08,0,0,1-9.75.1,42.65,42.65,0,0,1-8.79-1.57,30.86,30.86,0,0,1-6.36-2.71,25.08,25.08,0,0,1-4.65-3.45q-2-1.89-3.62-3.81l-32.85.12a10.26,10.26,0,0,0,2.8,3.52,31.1,31.1,0,0,0,3.57,2.57c1.18.73,2.21,1.34,3.1,1.82s1.39.91,1.48,1.27c.15.59-.25,1-1.2,1.3l-4.41,1.38a38.72,38.72,0,0,1-8.82-5.27,17.7,17.7,0,0,1-5.26-6.56Zm85.46,6.66a13.9,13.9,0,0,0,4.37-1.13,6.94,6.94,0,0,0,2.86-2.32,5.24,5.24,0,0,0,.85-3.54l-27.86.1a35,35,0,0,0,2.71,2.45,19,19,0,0,0,3.14,2.07,20.79,20.79,0,0,0,3.8,1.54,23.56,23.56,0,0,0,4.68.85A28.24,28.24,0,0,0,376.32,281.05Zm-54.19-17.47a17,17,0,0,0-5.25,1.29,8,8,0,0,0-3.3,2.52,5.63,5.63,0,0,0-1,3.69l30.92-.09a36.09,36.09,0,0,0-2.64-2.61,18.12,18.12,0,0,0-3.08-2.23,20.39,20.39,0,0,0-3.86-1.66,22.44,22.44,0,0,0-4.89-.9A35.9,35.9,0,0,0,322.13,263.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M399.37,207.29a292,292,0,0,0-95.74,0H247v31.55c0,19.61,46.8,35.5,104.53,35.5S456,258.45,456,238.84V207.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 351.5,
    cy: 207.29,
    rx: 104.53,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,207.33l-.47-1.88c-.11-.42.1-.74.62-1a4.76,4.76,0,0,1,1.88-.37l11,0a6.73,6.73,0,0,1,1-6,13.27,13.27,0,0,1,5.57-4.12,30.63,30.63,0,0,1,8.76-2.15,56.14,56.14,0,0,1,11-.06,37.69,37.69,0,0,1,8.54,1.63,29.5,29.5,0,0,1,6.25,2.86,27.22,27.22,0,0,1,4.68,3.64c1.35,1.33,2.62,2.65,3.81,4l29.89-.1a9.47,9.47,0,0,0-2.1-2.67,29.74,29.74,0,0,0-2.55-2.05c-.84-.59-1.57-1.08-2.2-1.5s-1-.75-1.05-1a.67.67,0,0,1,.25-.73,3.61,3.61,0,0,1,1.2-.53l3.63-1.06a36.21,36.21,0,0,1,7.1,4.13,15.14,15.14,0,0,1,4.55,5.42l12-.06.47,1.88c.1.39-.12.71-.65,1a4.92,4.92,0,0,1-2,.38l-8.89,0a6.56,6.56,0,0,1-.9,5.67,12.24,12.24,0,0,1-5,3.89,26.73,26.73,0,0,1-7.86,2.06,47.08,47.08,0,0,1-9.75.1,42,42,0,0,1-8.79-1.57,30.33,30.33,0,0,1-6.36-2.71,25.08,25.08,0,0,1-4.65-3.45q-2-1.89-3.62-3.81l-32.85.12a10.39,10.39,0,0,0,2.8,3.53,32.23,32.23,0,0,0,3.57,2.56c1.18.73,2.21,1.34,3.1,1.83s1.39.91,1.48,1.26c.15.59-.25,1-1.2,1.3l-4.41,1.38a38.72,38.72,0,0,1-8.82-5.27,17.7,17.7,0,0,1-5.26-6.56ZM376.32,214a13.9,13.9,0,0,0,4.37-1.13,6.94,6.94,0,0,0,2.86-2.32,5.21,5.21,0,0,0,.85-3.53l-27.86.09a33.09,33.09,0,0,0,2.71,2.45,19,19,0,0,0,3.14,2.07,20.79,20.79,0,0,0,3.8,1.54,22.86,22.86,0,0,0,4.68.85A28.24,28.24,0,0,0,376.32,214Zm-54.19-17.47a17.25,17.25,0,0,0-5.25,1.29,8,8,0,0,0-3.3,2.52,5.64,5.64,0,0,0-1,3.69l30.92-.09q-1.26-1.37-2.64-2.61a18.12,18.12,0,0,0-3.08-2.23,19.75,19.75,0,0,0-3.86-1.65,22.41,22.41,0,0,0-4.89-.91A35.9,35.9,0,0,0,322.13,196.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,270.4c-4-7.89-14.35-13.86-14.35-13.86-14.34,9.8-45.52,14-45.52,14a63.73,63.73,0,0,0,24.36-.11c7.69-1.6,11.94-4.11,19.73-3.95A38.08,38.08,0,0,1,456,270.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,338.82C449.36,330.94,439,325,439,325c-14.34,9.81-45.52,14-45.52,14a63.33,63.33,0,0,0,24.36-.11c7.68-1.59,11.94-4.11,19.72-3.94A38,38,0,0,1,453.3,338.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,408.51c-4-7.89-14.35-13.86-14.35-13.86-14.34,9.81-45.52,14-45.52,14a63.53,63.53,0,0,0,24.36-.11c7.69-1.59,11.94-4.11,19.73-3.94A38.1,38.1,0,0,1,456,408.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M453.49,443.41c-.14-2.31-.22-5.08-.51-7.82-.48-4.53-.86-9.09-1.7-13.56-2-10.89-7.2-16.2-18.12-18.1-6.44-1.12-13-1.47-19.54-2.16a5.48,5.48,0,0,1-2.07-.43c2.63-.16,5.28-.19,7.89-.5,5.35-.65,10.73-1.2,16-2.26,8.26-1.67,13.33-6.86,15.37-15.07,1.79-7.22,2.25-14.6,2.67-22a11.23,11.23,0,0,1,.34-2.24c.4,5,.72,10,1.24,15a82.32,82.32,0,0,0,1.41,8.38c1.88,9,7.36,14.55,16.33,16.13,6.77,1.2,13.66,1.69,20.5,2.46a20.52,20.52,0,0,0,2.48,0l0,.45c-.59,0-1.18.06-1.77.12-6.85.73-13.74,1.19-20.53,2.26-10.24,1.62-16,8.05-17.5,18.13C454.94,429.41,454.29,436.61,453.49,443.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M100.9,225.06a59.1,59.1,0,1,0-22,13.31l36.91,36.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M86,171.29a12.31,12.31,0,0,0-5.83-7.93c-7.24-4.29-16.64-1.36-20.81,5.94l-2,3.46-2-3.46c-4.17-7.3-13.57-10.23-20.81-5.94a12.31,12.31,0,0,0-5.83,7.93c-3.22,12.86,25.62,41,28.5,43.73v.24l.12-.12.12.12V215C60.37,212.26,89.21,184.15,86,171.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 588.58,
    y: 248.43,
    width: 31.33,
    height: 31.33,
    transform: "translate(868.35 -340.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 588.58,
    y: 296.55,
    width: 31.33,
    height: 31.33,
    transform: "translate(916.47 -292.04) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 588.58,
    y: 345.79,
    width: 31.33,
    height: 31.33,
    transform: "translate(965.71 -242.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 588.58,
    y: 388.31,
    width: 31.33,
    height: 31.33,
    transform: "translate(1008.23 -200.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M432.76,217.8c-.11-1.77-.18-3.88-.4-6-.36-3.47-.66-6.95-1.29-10.37-1.55-8.32-5.51-12.39-13.86-13.84-4.93-.85-9.95-1.12-14.94-1.65a4.29,4.29,0,0,1-1.58-.32c2-.13,4-.15,6-.39,4.09-.5,8.2-.91,12.23-1.73,6.32-1.27,10.19-5.24,11.75-11.52a90.55,90.55,0,0,0,2.05-16.8,8.22,8.22,0,0,1,.26-1.71c.3,3.83.55,7.67.94,11.5.23,2.15.64,4.28,1.08,6.4,1.44,6.85,5.63,11.12,12.48,12.33,5.18.92,10.45,1.29,15.68,1.89a17.19,17.19,0,0,0,1.9,0l0,.34c-.46,0-.91,0-1.36.09-5.23.56-10.5.91-15.7,1.74-7.82,1.23-12.2,6.15-13.37,13.85C433.87,207.1,433.37,212.6,432.76,217.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurwork);
export default __webpack_public_path__ + "static/media/ourwork.8aeea15cf37ff815ef0542ec252d6c55.svg";
export { ForwardRef as ReactComponent };